export interface PlanningObjectOperator extends more.EntityAPIResultExtended {
    ref_planning_object: PlanningObject;
    ref_vt_address_backoffice: Employee;
    ref_planning_object_status: PlanningObjectStatus;
    date_deadline: Date;
    date_start: Date;
    date_end: Date;
    duration_hh_mm: string;
    is_full_time: boolean;
    note: string,
    note_external: string;
    is_to_publish_in_web: boolean;
    alert_check: boolean;
    alert_period: AlertPeriod;
    base_for_alert_time: "date_start" | "alert_time";
    alert_time: Date;
    EL_planning_object_operator_master: Array<PlanningObjectOperator>;
    EL_ht_po_op_sp_id_enable: Array<HtPlanningObjectOperatorSpIdEnable>;
    ref_master?: PlanningObjectOperator;
    tmp_gDisp?: string;
    date_start_offset?: number;
    date_end_offset?: number;
    date_deadline_offset?: number;
    alert_time_offset?: number;
}

export type AlertPeriod = "";

export interface PlanningObject extends more.EntityAPIResultExtended {
    description: string;
    ref_primarily_responsible: Employee;
}

export interface PlanningObjectStatus extends more.EntityAPIResultExtended {
    description: string;
    coloration: more.EntityAPIColor;
}

export interface Employee extends more.EntityAPIResultExtended {
    gDisp_Name_Firstname: string;
    code: string;
}

export interface EmployeeExtended extends Employee {
    gDisp_Firstname_Name: string;
    ref_vw_telecom_addresses: VwTelecomAddresses;
}

export interface VwTelecomAddresses extends more.EntityAPIResultExtended {
    emailaddress: string
}


export interface HtPlanningObjectOperatorSpIdEnable extends more.EntityAPIResultExtended {
    tmp_status: string;
    tmp_ticket_no: string;
    tmp_title: string;
}

export interface HtAddressOnlineMeeting extends more.EntityAPIResultExtended {
    c_address_1: string;
    tmp_effective_email: string;
    ref_address: EmployeeExtended,
}

export enum SaleClasses {
    PlanningObjectOperator = "planning_object_operator"
}